import { useEffect, useRef, useCallback } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
//import { logoutUser } from '../redux/actions'; // you may already have this
import { updatelogindetails } from '../store/login_data';
import  { userLogout } from '../Restclient/datacollection';


const timeoutValues = {
  '5min': 5 * 60 * 1000,
  '10mins': 20 * 1000,
  '15min': 10 * 1000,
  '30min': 30 * 60 * 1000,
  '1hour': 60 * 60 * 1000,
  '2hours': 2 * 60 * 60 * 1000,
  '4hours': 4 * 60 * 60 * 1000,
};

const InactivityHandler = ({ timeoutKey, onTimeout }) => {
  
  
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const timerRef = useRef(null);
  // const timeoutDuration = timeoutValues[timeoutKey] || timeoutValues['15min'];

  //timeoutKey is in seconds, convert to milliseconds
  const timeoutDuration = timeoutKey && timeoutKey > 0 ? timeoutKey * 1000 : (15 * 60 * 1000);
  const username = useSelector((state) => state.logindata.username)
  const projectId = useSelector((state) => state.mainpagedata.selectedprojectname)
  const userdetails = useSelector((state) => state.logindata.userdetails)
  const { User_Role_ID, Organizationid, Projectlist } = useSelector((state) => state.logindata.userdetails);
  

  const logout = () => {
    let projectid = ((userdetails?.User_Role_Details?.Name == "EA_ADMIN") || (userdetails?.User_Role_Details?.Name == "ORGANIZATION_ADMIN") || (userdetails?.User_Role_Details?.Name == "ORG_ANALYST")) ? "All": userdetails?.Projectlist[0];
    userLogout(username, projectid)
    dispatch(updatelogindetails({userauthstate: 0,userpermissions: 0}));
    //dispatch(logoutUser()); // clear state
    localStorage.clear();   // remove tokens
    navigate('/');          // redirect to login
  };

  const handleTimeout = useCallback(() => {

    // Call the callback if provided (to show dialog), otherwise logout directly
    if (onTimeout) {
      onTimeout();
    } else {
      logout();
    }
  }, [onTimeout, logout]);

  const resetTimer = useCallback(() => {
    const now = new Date().toLocaleTimeString();
    
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(handleTimeout, timeoutDuration);
  }, [timeoutDuration, handleTimeout]);

  useEffect(() => {
    
    const events = ['mousemove', 'mousedown', 'keypress', 'scroll', 'touchstart'];
    events.forEach(event => window.addEventListener(event, resetTimer));
    
    resetTimer(); // start timer

    return () => {
      events.forEach(event => window.removeEventListener(event, resetTimer));
      clearTimeout(timerRef.current);
    };
  }, [timeoutDuration, resetTimer]);

  return null; // this component doesn’t render anything
};

export default InactivityHandler;
